import { useQuery } from '@tanstack/react-query';
import { fetchLeaderboard, type GraphFilters } from '../services/graphApi';

export function useLeaderboardQuery(
  eventId: number | null,
  splitId?: number,
  refreshIntervalMs = 0,
  filters?: GraphFilters
) {
  return useQuery({
    queryKey: ['leaderboard', eventId, splitId, filters],
    queryFn: () => fetchLeaderboard(eventId ?? 0, splitId ?? 0, filters),
    enabled: eventId != null && Boolean(splitId),
    refetchInterval: refreshIntervalMs > 0 ? refreshIntervalMs : false,
  });
}
